import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { KpiCard, type KpiTone } from "../KpiCard";

type DashboardMetricCardProps = {
  title: string;
  value: string;
  footer: ReactNode;
  icon: LucideIcon;
  tone: KpiTone;
  href?: string;
};

/** Indicateur des tableaux de bord Admin, Hôpital et Audit, au style des cartes d'indicateur (à placer dans une `KpiGrid`). */
export function DashboardMetricCard({ title, value, footer, icon, tone, href }: DashboardMetricCardProps) {
  return <KpiCard tone={tone} icon={icon} label={title} value={value} hint={footer} href={href} />;
}
